import React from 'react';
import { Divider, Typography } from "../../ecosystem/";
import { InHomePatientNameHeading } from "./index"

export const InHomePatientInputSection = ({
    className,
    children,
    patientName,
    subText
}) => {

    return (<>
        <div className={`row in-home-patient-input-section-container ${className ? className : ''}`}>
            <div className="col-12 in-home-input-section__heading">
                <InHomePatientNameHeading
                    patientName={patientName}
                    subText={subText}
                />
            </div>
            {children && <>
                <div className="col-12 in-home-input-section__body">
                    {children}
                </div>
                <div className="col-12 in-home-input-section__divider">
                    <Divider mTop="none" mBottom="none" mLeft="none" mRight="none" />
                </div>
            </>}
        </div>
    </>);
}

